export const MAX_LENGTH = 16 + 3;
export const MAX_DIGITS = 16;
export const DIGITS_GROUPS = 4;
